export default __webpack_public_path__ + "images/set/ribbon-logo-v1.png";